import { type Epic, combineEpics } from 'redux-observable';
import { filter, mergeMap } from 'rxjs';
import { request } from '@/core';
import { openSnackbar } from '@/core/features/snackbar';
import { deleteEventRequest } from '@/api/events';
import i18n from '@/i18n';
import { deleteEvent, fetchEvents, resetEvents } from '../actions';

const deleteEventEpic: Epic = (action$) =>
  action$.pipe(
    filter(deleteEvent.match),
    request(({ payload }) => deleteEventRequest(payload), deleteEvent),
  );

const deleteEventSucceededEpic: Epic = (action$) =>
  action$.pipe(
    filter(deleteEvent.succeeded.match),
    mergeMap(
      ({
        payload: {
          originalData: { page, propertyId },
        },
      }) => [
        openSnackbar({
          snackbarType: 'success',
          snackbarMessage: i18n.t('DELETE_EVENT_SUCCESS'),
        }),
        resetEvents({ page, propertyId }),
        fetchEvents({ propertyId, pagination: { page } }),
      ],
    ),
  );

export default combineEpics(deleteEventEpic, deleteEventSucceededEpic);
